<div class="py-2 px-4 pt-0">
  <h3 class="font-thin border-b border-gray-300 mb-2 p-1">VI. L’ OPTIMISATION DE L' UTILISATION</h3>
</div>
